<template>
    <div>

        <el-row class="column-name" justify="start">
            <span>基本信息</span>
        </el-row>

        <el-form label-position="right" ref="kpiDetailInfo" :model="kpiDetailInfo" label-width="120px">

            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="工单编号" prop="kpino">
                        <el-input v-model="kpiDetailInfo.kpino" size="small" class="width70" disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="数据中心" prop="dept">
                        <DeptSelect size="small" v-model="kpiDetailInfo.deptid" disabled="true" class="width70">
                        </DeptSelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="考评月份" prop="kpidate">
                        <el-input v-model="kpiDetailInfo.kpidateFront" size="small" class="width70" disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="考评责任人" prop="owner">
                        <el-input v-model="kpiDetailInfo.owner" size="small" class="width70" disabled="true"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>

    </div>
</template>

<script>

    import DeptSelect from '@/components/dept'

    import KpiServer from '@/api/kpi/index'
    import {createNamespacedHelpers} from 'vuex'

    const kpiNSHelper = createNamespacedHelpers( "kpi" );

    export default {

        name: "kpiDetail",

        components: {
            DeptSelect,
        },

        data() {

            return {
                kpiDetailInfo: {}
            }

        },

        methods: {},

        watch: {

            kpiInfo: {
                handler: function (newVal, oldVal) {
                    KpiServer.kpi.get(newVal.id).then((responseBody) => {
                        responseBody.data.data.kpidateFront = new Date(responseBody.data.data.kpidate).Format('yyyy-MM');
                        this.kpiDetailInfo = responseBody.data.data;
                    });
                }
            },

        },

        computed: {
            ...kpiNSHelper.mapGetters(['kpiInfo']),
        },

    }

</script>